import { t } from '@ps/lang'
import { isPlainObject } from 'lodash-es'

export enum SceneErrorType {
  /**
   * 场景中没有视频
   */
  NoVideo,
  /**
   * 没有可放置的位置空间
   */
  NoSpace,
  /**
   * 添加到轨道失败
   * @description 一般指验证前置条件后，最后执行插入动作时候，找不到目标或者其他原因
   */
  InsertFail,
  /**
   * 找不到目标元件
   */
  SegmentNotFound,
  /**
   * 元件对应节点创建失败
   */
  CreateNodeFail,
}

const SceneErrorMessages: Record<SceneErrorType, string> = {
  [SceneErrorType.NoVideo]: t('interactiveVideo.iv.sceneErrorType.noVideo'),
  [SceneErrorType.NoSpace]: t('interactiveVideo.iv.sceneErrorType.noSpace'),
  [SceneErrorType.InsertFail]: t(
    'interactiveVideo.iv.sceneErrorType.insertFail',
  ),
  [SceneErrorType.SegmentNotFound]: t(
    'interactiveVideo.iv.sceneErrorType.segmentNotFound',
  ),
  [SceneErrorType.CreateNodeFail]: t(
    'interactiveVideo.iv.sceneErrorType.createNodeFail',
  ),
}

const SceneErrorSymbol = '__is_scene_error' // Symbol('__is_scene_error')

export interface SceneError<T extends SceneErrorType = SceneErrorType> {
  readonly [SceneErrorSymbol]: true
  type: T
  message: string
}

export type InferSceneErrorType<T> = T extends {
  [SceneErrorSymbol]: true
  type: infer P
}
  ? [P] extends [SceneErrorType]
    ? SceneError<P>
    : never
  : never

export function createSceneError<T extends SceneErrorType>(
  type: T,
): SceneError<T> {
  return {
    [SceneErrorSymbol]: true,
    message: SceneErrorMessages[type],
    type,
  }
}
export function isSceneError<
  T extends Record<any, any>,
  R = InferSceneErrorType<T>,
>(error: T): error is R extends T ? R : never {
  return Boolean(isPlainObject(error) && SceneErrorSymbol in error)
}
